import React from 'react';
import ReactDOM from 'react-dom';
import WebFont from 'webfontloader';
import App from './App';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faCalendarAlt, faCheckSquare, faSquare, faAngleDown, faExternalLinkAlt, faUserLock, faExclamationTriangle, faChevronLeft, faTimes } from '@fortawesome/free-solid-svg-icons'

library.add(fab, faCheckSquare, faSquare, faAngleDown, faExternalLinkAlt, faCalendarAlt, faUserLock, faExclamationTriangle, faChevronLeft, faTimes)

WebFont.load({
  google: {
    families: ['Work Sans:100,300,400,700', 'sans-serif']
  }
});

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js